/*=========================================================================================
  File Name: constant.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import {constRouter} from "./store/constant";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return {x: 0, y: 0}
    },
    routes: [

        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                // {
                //     path: '/',
                //     redirect: '/dashboard',
                // },
                {
                    path: '/dashboard-hrm',
                    name: 'dashboard',
                    component: () => import('./views/user-pages/hrm-module/DashboardHRM.vue'),
                    meta: {
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/dashboard-crm',
                    name: 'dashboard-crm',
                    component: () => import('./views/user-pages/crm-module/DashboardCRM.vue'),
                    meta: {
                        rule: 'organization_user',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/user-info',
                    name: 'user-info',
                    component: () => import('./views/pages/user/UserView.vue'),
                    meta: {
                        rule: 'organization_user',
                    }
                },
                {
                    path: '/user/reset-password',
                    name: 'reset-password-user',
                    component: () => import('./views/pages/user/ResetPassword.vue'),
                    meta: {
                        rule: 'organization_user',
                    }
                },
                //Organization
                {
                    path: '/admin/reset-password',
                    name: 'reset-password-admin',
                    component: () => import('./views/admin-pages/reset-password/ResetPasswordAmin.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/admin/manage-organization',
                    name: 'manage-organization',
                    component: () => import('./views/admin-pages/organization/Organization'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/admin/manage-organization/add',
                    name: 'add-organization',
                    component: () => import('./views/admin-pages/organization/OrganizationInformation'),
                    meta: {
                        pageTitle: 'Thêm tổ chức',
                        parent: 'manage-organization',
                        rule: 'admin',
                    }
                },
                {
                    path: '/admin/manage-organization/edit',
                    name: 'edit-organization',
                    component: () => import('./views/admin-pages/organization/OrganizationInformation'),
                    meta: {
                        pageTitle: 'Cập nhật tổ chức',
                        parent: 'manage-organization',
                        rule: 'admin',
                    }
                },
                {
                    path: '/admin/manage-master-work-shift',
                    name: 'manage-master-work-shift',
                    component: () => import('./views/admin-pages/master-work-shift/WorkShift'),
                    meta: {
                        pageTitle: 'Cập nhật ca làm việc',
                        rule: 'admin',
                        parent: 'manage-master-work-shift'

                    }
                },
                {
                    path: '/user/register-organization-package',
                    name: 'register-organization-package',
                    component: () => import('./views/user-pages/user-package/UserPackage'),
                    meta: {
                        pageTitle: 'Đăng kí gói dịch vụ',
                        rule: 'organization_user',
                        parent: 'register-organization-package'
                    }
                },
                {
                    path: '/user/organization-package',
                    name: 'user-organization-package',
                    component: () => import('./views/user-pages/user-package/UserPackageInformation'),
                    meta: {
                        pageTitle: 'Gói đăng kí',
                        rule: 'organization_user',
                    }
                },
                {
                    path: '/user/history-register-organization-package',
                    name: 'history-register-organization-package',
                    component: () => import('./views/user-pages/user-package/UserRegisterPackageHistory'),
                    meta: {
                        pageTitle: 'Lich sử yêu cầu',
                        rule: 'organization_user',
                        parent: 'history-register-organization-package'
                    }
                },
                {
                    path: '/admin/history-register-package',
                    name: 'history-register-package',
                    component: () => import('./views/admin-pages/history-package/HistoryPackageHistory'),
                    meta: {
                        pageTitle: 'Lich sử yêu cầu',
                        rule: 'admin',
                        parent: 'history-register-package'
                    }
                },
                {
                    path: '/admin/organization-package',
                    name: 'organization-package',
                    component: () => import('./views/admin-pages/organization-package/OrganizationPackage'),
                    meta: {
                        pageTitle: 'Gói dịch vụ',
                        rule: 'admin',
                        parent: 'organization-package'
                    }
                },
                {
                    path: '/admin/organization-package/add',
                    name: 'add-organization-package',
                    component: () => import('./views/admin-pages/organization-package/OrganizationPackageInformation'),
                    meta: {
                        pageTitle: 'Thêm gói dịch vụ',
                        rule: 'admin',
                        parent: 'organization-package'
                    }
                },
                {
                    path: '/admin/organization-package/edit',
                    name: 'edit-organization-package',
                    component: () => import('./views/admin-pages/organization-package/OrganizationPackageInformation'),
                    meta: {
                        pageTitle: 'Sửa gói dịch vụ',
                        rule: 'admin',
                        parent: 'organization-package'
                    }
                },

                // Permision
                {
                    path: '/user/manage-permision',
                    name: 'user-manage-permision',
                    component: () =>
                        import('./views/user-pages/hrm-module/permision/Permision'),
                    meta: {
                        pageTitle: 'Quản lý quyền',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/add-permision',
                    name: 'user-add-permision',
                    component: () =>
                        import('./views/user-pages/hrm-module/permision/PermisionInformation'),
                    meta: {
                        parent: 'user-manage-permision',
                        pageTitle: 'Thêm mới quyền',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/edit-permision',
                    name: 'user-edit-permision',
                    component: () =>
                        import('./views/user-pages/hrm-module/permision/PermisionInformation'),
                    meta: {
                        parent: 'user-manage-permision',
                        pageTitle: 'Cập nhật quyền',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },

                {
                    path: '/admin/permission-function',
                    name: 'permission-function',
                    component: () => import('./views/admin-pages/permission/Permission'),
                    meta: {
                        pageTitle: 'Phân quyền chức năng',
                        rule: 'admin',
                        parent: 'permission-function',
                        space: 'hrm'
                    }
                },
                {
                    path: '/admin/permission-function/add',
                    name: 'permission-function-add',
                    component: () => import('./views/admin-pages/permission/PermissionInformation'),
                    meta: {
                        pageTitle: 'Thêm mới quyền chức năng',
                        rule: 'admin',
                        parent: 'permission-function'
                    }
                },
                {
                    path: '/admin/permission-function/edit',
                    name: 'permission-function-edit',
                    component: () => import('./views/admin-pages/permission/PermissionInformation'),
                    meta: {
                        pageTitle: 'Sửa quyền chức năng',
                        rule: 'admin',
                        parent: 'permission-function'
                    }
                },
                {
                    path: '/admin/manage-camera',
                    name: 'admin-manage-camera',
                    component: () => import('./views/admin-pages/camera/Camera'),
                    meta: {
                        pageTitle: 'Danh sách Camera',
                        rule: 'admin',
                        parent: 'admin-manage-camera'
                    }
                },

                // Role
                {
                    path: '/user/manage-position',
                    name: 'user-manage-position',
                    component: () =>
                        import('./views/user-pages/hrm-module/position/Position'),
                    meta: {
                        pageTitle: 'Quản lý chức vụ',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/add-position',
                    name: 'user-add-position',
                    component: () =>
                        import('./views/user-pages/hrm-module/position/PositionInfomation'),
                    meta: {
                        pageTitle: 'Thêm mới chức vụ',
                        rule: 'organization_user',
                        parent: 'user-manage-position',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/edit-position',
                    name: 'user-edit-position',
                    component: () =>
                        import('./views/user-pages/hrm-module/position/PositionInfomation'),
                    meta: {
                        pageTitle: 'Cập nhật chức vụ',
                        rule: 'organization_user',
                        parent: 'user-manage-position',
                        space: 'hrm'
                    }
                },

                {
                    path: '/admin/edit-camera',
                    name: 'edit-admin-manage-camera',
                    component: () => import('./views/admin-pages/camera/CameraInformation'),
                    meta: {
                        pageTitle: 'Cập nhật Camera',
                        rule: 'admin',
                        parent: 'admin-manage-camera'
                    }
                },
                {
                    path: '/user/organization-info',
                    name: 'user-organization-info',
                    component: () => import('./views/user-pages/hrm-module/organization/Organization'),
                    meta: {
                        pageTitle: 'Thông tin tổ chức',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                //Branch
                {
                    path: constRouter.organization_branch_all,
                    name: 'user-organization-branch',
                    component: () => import('./views/user-pages/hrm-module/branch/Branch'),
                    meta: {
                        pageTitle: 'Danh sách chi nhánh',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: constRouter.organization_branch_add,
                    name: 'user-add-organization-branch',
                    component: () => import('./views/user-pages/hrm-module/branch/BranchInformation'),
                    meta: {
                        pageTitle: 'Thêm chi nhánh',
                        parent: 'user-organization-branch',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: constRouter.organization_branch_edit,
                    name: 'user-edit-organization-branch',
                    component: () => import('./views/user-pages/hrm-module/branch/BranchInformation'),
                    meta: {
                        pageTitle: 'Cập nhật chi nhánh',
                        parent: 'user-organization-branch',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },

                //Device
                {
                    path: '/user/manage-device',
                    name: 'user-manage-device',
                    component: () => import('./views/user-pages/hrm-module/device/Device'),
                    meta: {
                        pageTitle: 'Danh sách tài sản',
                        rule: 'organization_user',
                        parent: 'manage-device',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/add-device',
                    name: 'user-add-device',
                    component: () => import('./views/user-pages/hrm-module/device/DeviceInformation'),
                    meta: {
                        pageTitle: 'Thêm tài sản',
                        parent: 'manage-device',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/edit-device',
                    name: 'user-edit-device',
                    component: () => import('./views/user-pages/hrm-module/device/DeviceInformation'),
                    meta: {
                        pageTitle: 'Cập nhật tài sản',
                        parent: 'manage-device',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/assign-device-history',
                    name: 'user-assign-device-history',
                    component: () => import('./views/user-pages/hrm-module/device/AssignDeviceHistory'),
                    meta: {
                        pageTitle: 'Lịch sử tài sản',
                        rule: 'organization_user',
                        parent: 'user-assign-device-history',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/assign-device',
                    name: 'user-assign-device',
                    component: () => import('./views/user-pages/hrm-module/device/AssignDeviceInformation'),
                    meta: {
                        pageTitle: 'Cấp phát tài sản',
                        rule: 'organization_user',
                        parent: 'manage-device',
                        space: 'hrm'
                    }
                },
                // Equipment
                {
                    path: '/user/manage-equipment',
                    name: 'user-manage-equipment',
                    component: () => import('./views/user-pages/hrm-module/equipment/Equipment'),
                    meta: {
                        pageTitle: 'Danh sách vật dụng',
                        rule: 'organization_user',
                        parent: 'manage-equipment',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/add-equipment',
                    name: 'user-add-equipment',
                    component: () => import('./views/user-pages/hrm-module/equipment/EquipmentInformation'),
                    meta: {
                        pageTitle: 'Thêm vật dụng',
                        parent: 'manage-equipment',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/edit-equipment',
                    name: 'user-edit-equipment',
                    component: () => import('./views/user-pages/hrm-module/equipment/EquipmentInformation'),
                    meta: {
                        pageTitle: 'Cập nhật vật dụng',
                        parent: 'manage-equipment',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/assign-equipment-history',
                    name: 'user-assign-equipment-history',
                    component: () => import('./views/user-pages/hrm-module/equipment/AssignEquipmentHistory'),
                    meta: {
                        pageTitle: 'Lịch sử vật dụng',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },

                {
                    path: '/user/assigned-equipment',
                    name: 'user-assigned-equipment',
                    component: () => import('./views/user-pages/hrm-module/equipment/AssignedEquipment'),
                    meta: {
                        pageTitle: 'Cấp phát vật dụng',
                        rule: 'organization_user',
                        parent: 'manage-equipment',
                        space: 'hrm'
                    }
                },

                {
                    path: '/user/assign-equipment',
                    name: 'user-assign-equipment',
                    component: () => import('./views/user-pages/hrm-module/equipment/AssignEquipmentInformation'),
                    meta: {
                        pageTitle: 'Thông tin tài sản',
                        rule: 'organization_user',
                        parent: 'manage-equipment',
                        space: 'hrm'
                    }
                },

                // {
                //     path: '/user/manage-camera',
                //     name: 'user-manage-camera',
                //     component: () => import('./views/user-pages/camera/Camera'),
                //     meta: {
                //         pageTitle: 'Danh sách camera',
                //         rule: 'organization_user',
                //         parent: 'user-manage-camera'
                //     }
                // },
                {
                    path: '/user/potential-customers',
                    name: 'user-customer-customers',
                    component: () => import('./views/user-pages/crm-module/customer/PotentialCustomers.vue'),
                    meta: {
                        rule: 'organization_user',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/opportunistic-customers',
                    name: 'user-opportunistic-customers',
                    component: () => import('./views/user-pages/crm-module/customer/OpportunisticCustomers.vue'),
                    meta: {
                        rule: 'organization_user',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/booking-customers',
                    name: 'user-booking-customers',
                    component: () => import('./views/user-pages/crm-module/customer/BookingCustomers.vue'),
                    meta: {
                        rule: 'organization_user',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/arrive-customers',
                    name: 'user-arrive-customers',
                    component: () => import('./views/user-pages/crm-module/customer/ArriveCustomers.vue'),
                    meta: {
                        rule: 'organization_user',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/customer',
                    name: 'user-customer',
                    component: () => import('./views/user-pages/crm-module/customer/Customer'),
                    meta: {
                        rule: 'organization_user',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/add-customer',
                    name: 'user-add-customer',
                    component: () => import('./views/user-pages/crm-module/customer/CustomerInformation'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-customer',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/edit-customer',
                    name: 'user-edit-customer',
                    component: () => import('./views/user-pages/crm-module/customer/CustomerInformation'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-customer',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/customer-general',
                    name: 'user-customer-general',
                    component: () => import('./views/user-pages/crm-module/customer/CustomerGeneral'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-customer-general',
                        space: 'crm'
                    }
                },
                // {
                //     path: '/user/add-camera',
                //     name: 'user-add-camera',
                //     component: () => import('./views/user-pages/camera/CameraInformation'),
                //     meta: {
                //         pageTitle: 'Thêm camera',
                //         rule: 'organization_user',
                //         parent: 'user-manage-camera'
                //     }
                // },

                // {
                //     path: '/user/manage-camera/show',
                //     name: 'user-show-camera',
                //     component: () => import('./views/user-pages/camera/CameraRealTime'),
                //     meta: {
                //         pageTitle: '',
                //         rule: 'organization_user',
                //         parent: 'user-manage-camera'
                //     }
                // },
                // {
                //     path: '/user/edit-camera',
                //     name: 'user-edit-camera',
                //     component: () => import('./views/user-pages/camera/C' +
                //         'ameraInformation'),
                //     meta: {
                //         pageTitle: 'Cập nhật camera',
                //         rule: 'organization_user',
                //         parent: 'user-manage-camera'
                //     }
                // },
                // {
                //     path: '/user/manage-camera-layout',
                //     name: 'user-manage-camera-layout',
                //     component: () => import('./views/user-pages/camera/CameraLayout'),
                //     meta: {
                //         pageTitle: 'Danh sách camera',
                //         rule: 'organization_user',
                //         parent: 'user-manage-camera-layout'
                //     }
                // },
                //Multipurpose-Room
                {
                    path: '/user/manage-multipurpose-room',
                    name: 'user-manage-manage-multipurpose-room',
                    component: () => import('./views/user-pages/hrm-module/multipurpose-room/MultipurposeRoom'),
                    meta: {
                        pageTitle: 'Lịch phòng họp',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/manage-meeting-room',
                    name: 'user-manage-meeting-room',
                    component: () => import('./views/user-pages/hrm-module/multipurpose-room/MeetingRoom'),
                    meta: {
                        pageTitle: 'Phòng họp',
                        rule: 'organization_user',
                        parent: 'user-manage-manage-multipurpose-room',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/add-meeting-room',
                    name: 'user-add-meeting-room',
                    component: () => import('./views/user-pages/hrm-module/multipurpose-room/MeetingRoomInformation'),
                    meta: {
                        pageTitle: 'Thêm phòng họp',
                        rule: 'organization_user',
                        parent: 'user-manage-manage-multipurpose-room',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/edit-meeting-room',
                    name: 'user-edit-meeting-room',
                    component: () => import('./views/user-pages/hrm-module/multipurpose-room/MeetingRoomInformation'),
                    meta: {
                        pageTitle: 'Cập nhật phòng họp',
                        rule: 'organization_user',
                        parent: 'user-manage-manage-multipurpose-room',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/meeting-schedule',
                    name: 'user-meeting-schedule',
                    component: () => import('./views/user-pages/hrm-module/multipurpose-room/MeetingSchedule'),
                    meta: {
                        pageTitle: 'Lịch họp',
                        rule: 'organization_user',
                        parent: 'user-manage-manage-multipurpose-room',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/book-a-meeting',
                    name: 'user-book-a-meeting',
                    component: () => import('./views/user-pages/hrm-module/multipurpose-room/BookAMeetingInformation'),
                    meta: {
                        pageTitle: 'Đặt lịch họp',
                        rule: 'organization_user',
                        parent: 'user-manage-manage-multipurpose-room',
                        space: 'hrm'
                    }
                },
                //Camera-Group-Admin
                // {
                //     path: '/user/manage-camera-group',
                //     name: 'user-manage-camera-group',
                //     component: () => import('./views/user-pages/camera-group-admin/CameraGroup'),
                //     meta: {
                //         pageTitle: 'Quản trị nhóm Camera',
                //         rule: 'organization_user',
                //         parent: 'user-manage-camera-group'
                //     }
                // },
                // {
                //     path: '/user/add-camera-group',
                //     name: 'user-add-camera-group',
                //     component: () => import('./views/user-pages/camera-group-admin/CameraGroupInformation'),
                //     meta: {
                //         pageTitle: 'Thêm nhóm Camera',
                //         rule: 'organization_user',
                //         parent: 'user-manage-camera-group'
                //     }
                // },
                // {
                //     path: '/user/edit-camera-group',
                //     name: '/user-edit-camera-group',
                //     component: () => import('./views/user-pages/camera-group-admin/CameraGroupInformation'),
                //     meta: {
                //         pageTitle: 'Cập nhật nhóm camera',
                //         rule: 'organization_user',
                //         parent: 'user-manage-camera-group'
                //     }
                // },
                // Report
                {
                    path: '/user/manage-stranger',
                    name: 'manage-report-stranger',
                    component: () => import('./views/user-pages/report/ReportStranger'),
                    meta: {
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                // Report Tu Tập
                {
                    path: '/user/manage-crowded',
                    name: 'manage-report-crowded',
                    component: () => import('./views/user-pages/report/ReportCrowded'),
                    meta: {
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                // Report Tụ Tập Detail
                {
                    path: '/user/detail-crowded',
                    name: 'detail-report-crowded',
                    component: () => import('./views/user-pages/report/ReportCrowdedDetail'),
                    meta: {
                        pageTitle: 'Thông tin chi tiết tụ tập',
                        rule: 'organization_user',
                        parent: 'manage-report-crowded',
                        space: 'hrm'
                    }
                },
                //Camera Report
                {
                    path: '/user/manage-stranger/show',
                    name: 'show-camera-stranger',
                    component: () => import('./views/user-pages/report/ReportRealTime'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'manage-report-stranger',
                        space: 'hrm'
                    }
                },
                //Report Detail
                {
                    path: '/user/detail-stranger/',
                    name: 'detail-report-stranger',
                    component: () => import('./views/user-pages/report/ReportStrangerDetail'),
                    meta: {
                        pageTitle: 'Thông tin xâm nhập',
                        rule: 'organization_user',
                        parent: 'manage-report-stranger',
                        space: 'hrm'
                    }
                },
                //Face Id
                {
                    path: '/user/manage-face-id',
                    name: 'user-manage-face-id',
                    component: () => import('./views/user-pages/camera/CameraFaceId'),
                    meta: {
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                //Wifi
                {
                    path: '/user/manage-wifi',
                    name: 'user-manage-wifi',
                    component: () => import('./views/user-pages/hrm-module/wifi/Wifi'),
                    meta: {
                        pageTitle: 'Danh sách wifi',
                        rule: 'organization_user',
                        parent: 'user-manage-wifi',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/add-wifi',
                    name: 'user-add-wifi',
                    component: () => import('./views/user-pages/hrm-module/wifi/WifiInformation'),
                    meta: {
                        pageTitle: 'Thêm wifi',
                        rule: 'organization_user',
                        parent: 'user-manage-wifi',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/edit-wifi',
                    name: 'user-edit-wifi',
                    component: () => import('./views/user-pages/hrm-module/wifi/WifiInformation'),
                    meta: {
                        pageTitle: 'Cập nhật wifi',
                        rule: 'organization_user',
                        parent: 'user-manage-wifi',
                        space: 'hrm'
                    }
                },

                //QR-Code
                {
                    path: '/user/manage-qr-code',
                    name: 'user-manage-qr-code',
                    component: () => import('./views/user-pages/hrm-module/qr-code/QRCodeCheckIn'),
                    meta: {
                        rule: 'organization_user',
                        pageTitle: 'Danh sách QR Code',
                        parent: 'user-manage-qr-code',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/add-qr-code',
                    name: 'user-add-qr-code',
                    component: () => import('./views/user-pages/hrm-module/qr-code/QRCodeInformation'),
                    meta: {
                        pageTitle: 'Thêm mới mã QR',
                        rule: 'organization_user',
                        parent: 'user-manage-qr-code',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/edit-qr-code',
                    name: 'user-edit-qr-code',
                    component: () => import('./views/user-pages/hrm-module/qr-code/QRCodeInformation'),
                    meta: {
                        pageTitle: 'Cập nhật mã QR',
                        rule: 'organization_user',
                        parent: 'user-manage-qr-code',
                        space: 'hrm'
                    }
                },
                //New & Event
                {
                    path: '/user/manage-news-event',
                    name: 'user-manage-news-event',
                    component: () => import('./views/user-pages/crm-module/news-events/NewsAndEvents'),
                    meta: {
                        rule: 'organization_user',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/info-news-event',
                    name: 'user-info-news-event',
                    component: () => import('./views/user-pages/crm-module/news-events/InfoNewsAndEvents'),
                    meta: {
                        pageTitle: 'Thêm tin tức, sự kiện',
                        rule: "organization_user",
                        parent: 'user-manage-news-event',
                        space: 'crm'
                    }
                },

                //News
                {
                    path: '/user/manage-news',
                    name: 'user-manage-news',
                    component: () => import('./views/user-pages/hrm-module/news/News'),
                    meta: {
                        pageTitle: 'Danh sách bảng tin',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/add-news',
                    name: 'user-add-news',
                    component: () => import('./views/user-pages/hrm-module/news/NewsInformation'),
                    meta: {
                        pageTitle: 'Thêm bảng tin',
                        rule: 'organization_user',
                        parent: 'user-manage-news',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/edit-news',
                    name: 'user-edit-news',
                    component: () => import('./views/user-pages/hrm-module/news/NewsInformation'),
                    meta: {
                        pageTitle: 'Cập nhật bảng tin',
                        rule: 'organization_user',
                        parent: 'user-manage-news',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/evaluate-news',
                    name: 'user-evaluate-news',
                    component: () => import('./views/user-pages/hrm-module/news/Evaluate'),
                    meta: {
                        pageTitle: 'Đánh giá',
                        rule: 'organization_user',
                        parent: 'user-manage-news',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/selection-news',
                    name: 'user-selection-news',
                    component: () => import('./views/user-pages/hrm-module/news/Selection'),
                    meta: {
                        pageTitle: 'Đánh giá',
                        rule: 'organization_user',
                        parent: 'user-manage-news',
                        space: 'hrm'
                    }
                },
                //Notification
                {
                    path: '/user/manage-notification',
                    name: 'user-manage-notification',
                    component: () => import('./views/user-pages/notification/Notification'),
                    meta: {
                        pageTitle: 'Danh sách thông báo',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/add-notification',
                    name: 'user-add-notification',
                    component: () => import('./views/user-pages/notification/NotificationInformation'),
                    meta: {
                        pageTitle: 'Thêm thông báo',
                        rule: 'organization_user',
                        parent: 'user-manage-notification',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/edit-notification',
                    name: 'user-edit-notification',
                    component: () => import('./views/user-pages/notification/NotificationInformation'),
                    meta: {
                        pageTitle: 'Cập nhật thông báo',
                        rule: 'organization_user',
                        parent: 'user-manage-notification',
                        space: 'hrm'
                    }
                },
                //Event
                {
                    path: '/user/manage-event',
                    name: 'user-manage-event',
                    component: () => import('./views/user-pages/event/Event'),
                    meta: {
                        pageTitle: 'Danh sách sự kiện',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                //Leave
                {
                    path: '/user/manage-leave',
                    name: 'user-manage-leave',
                    component: () => import('./views/user-pages/hrm-module/leave/Leave'),
                    meta: {
                        pageTitle: 'Đơn xin nghỉ',
                        rule: 'organization_user',
                        parent: 'user-manage-leave',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/assign-leave',
                    name: 'user-add-leave',
                    component: () => import('./views/user-pages/hrm-module/leave/LeaveInformation'),
                    meta: {
                        pageTitle: 'Cập nhật đơn xin nghỉ',
                        rule: 'organization_user',
                        parent: 'user-manage-leave',
                        space: 'hrm'
                    }
                },

                {
                    path: '/user/edit-leave',
                    name: 'user-edit-leave',
                    component: () => import('./views/user-pages/hrm-module/leave/LeaveInformation'),
                    meta: {
                        pageTitle: 'Cập nhật đơn xin nghỉ',
                        rule: 'organization_user',
                        parent: 'user-manage-leave',
                        space: 'hrm'
                    }
                },

                {
                    path: '/user/manage-work-shift-branch',
                    name: 'manage-work-shift-branch',
                    component: () => import('./views/user-pages/hrm-module/workshift/OrganizationBranchWorkShift'),
                    meta: {
                        pageTitle: 'Danh sách ca làm việc',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                //WorkShift
                {
                    path: '/admin/edit-master-work-shift',
                    name: 'edit-master-work -shift',
                    component: () => import('./views/admin-pages/master-work-shift/WorkShiftInformation'),
                    meta: {
                        rule: 'admin',
                        pageTitle: 'Cập nhật ca làm việc',
                        parent: 'manage-master-work-shift'

                    }
                },
                {
                    path: '/user/manage-work-shift',
                    name: 'manage-work-shift',
                    component: () => import('./views/user-pages/hrm-module/workshift/WorkShift'),
                    meta: {
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/manage-branch-work-shift',
                    name: 'manage-branch-work-shift',
                    component: () => import('./views/user-pages/hrm-module/workshift/OrganizationBranchWorkShift'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'manage-branch-work-shift',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/add-work-shift',
                    name: 'user-add-work-shift',
                    component: () => import('./views/user-pages/hrm-module/workshift/WorkShiftInformation'),
                    meta: {
                        pageTitle: 'Thêm ca làm việc',
                        rule: 'organization_user',
                        parent: 'manage-branch-work-shift',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/edit-work-shift',
                    name: 'edit-add-work-shift',
                    component: () => import('./views/user-pages/hrm-module/workshift/WorkShiftInformation'),
                    meta: {
                        pageTitle: 'Cập nhật ca làm việc',
                        rule: 'organization_user',
                        parent: 'manage-branch-work-shift',
                        space: 'hrm'
                    }
                },

                {
                    path: constRouter.employee_all,
                    name: 'user-manage-employee',
                    component: () => import('./views/user-pages/hrm-module/employee/Employee'),
                    meta: {
                        pageTitle: 'Danh sách nhân sự',
                        rule: 'organization_user',
                        parent: 'user-manage-employee',
                        space: 'hrm'
                    }
                },
                {
                    path: constRouter.employee_add,
                    name: 'user-add-employee',
                    component: () => import('./views/user-pages/hrm-module/employee/EmployeeInformation'),
                    meta: {
                        pageTitle: 'Thêm nhân sự',
                        rule: 'organization_user',
                        parent: 'user-manage-employee',
                        space: 'hrm'
                    }
                },
                {
                    path: constRouter.employee_edit,
                    name: 'user-edit-employee',
                    component: () => import('./views/user-pages/hrm-module/employee/EmployeeInformation'),
                    meta: {
                        pageTitle: 'Cập nhật nhân sự',
                        rule: 'organization_user',
                        parent: 'user-manage-employee',
                        space: 'hrm'
                    }
                },

                {
                    path: '/user/manage-work-shift-by-day',
                    name: 'manage-work-shift-by-day',
                    component: () => import('./views/user-pages/hrm-module/workshiftbyday/Employee'),
                    meta: {
                        pageTitle: 'Nhân sự làm việc theo ngày',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/setting-work-shift-by-day',
                    name: 'user-setting-work-shift-by-day',
                    component: () => import('./views/user-pages/hrm-module/workshiftbyday/SettingWorkShiftByDay'),
                    meta: {
                        pageTitle: 'Ca làm việc theo ngày',
                        rule: 'organization_user',
                        parent: 'manage-work-shift-by-day',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/in-out-history',
                    name: 'user-in-out-history',
                    component: () => import('./views/user-pages/hrm-module/in-out-history/InOutHistory'),
                    meta: {
                        pageTitle: 'Lịch sử ra vào',
                        rule: 'organization_user',
                        parent: 'user-in-out-history',
                        space: 'hrm'
                    }
                },
                // {
                //   path: '/user/confirm-time-keeping',
                //   name: 'confirm-time-keeping',
                //   component: () => import('./views/user-pages/confirmTimeKeeping/ConfirmTimeKeeping'),
                //   meta: {
                //     pageTitle: 'Xác nhận chấm công',
                //     rule: 'organization_user',
                //   }
                // },
                {
                    path: '/user/update-in-out',
                    name: 'update-in-out',
                    component: () => import('./views/user-pages/hrm-module/update-in-out/UpdateInOut'),
                    meta: {
                        pageTitle: 'Danh sách khiếu nại',
                        rule: 'organization_user',
                        parent: 'update-in-out',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/update-in-out-by-id',
                    name: 'update-in-out-by-id',
                    component: () => import('./views/user-pages/hrm-module/update-in-out/InOutInformation'),
                    meta: {
                        pageTitle: 'Tạo đơn khiếu nại',
                        rule: 'organization_user',
                        parent: 'update-in-out',
                        space: 'hrm'
                    }
                },
                // {
                //     path: '/user/in-out-history-customer',
                //     name: 'user-in-out-history-customer',
                //     component: () => import('./views/user-pages/in-out-history-customer/InOutHistoryCustomer'),
                //     meta: {
                //         rule: 'organization_user',
                //         parent: 'user-in-out-history-customer'
                //     }
                // },
                {
                    path: '/user/in-out-history-customer-realtime',
                    name: 'user-in-out-history-customer-realtime',
                    component: () => import('./views/user-pages/crm-module/in-out-history-customer/InOutHistoryCustomerRealtime'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-in-out-history-customer-realtime',
                        space: 'crm'
                    }
                },
                // {
                //     path: '/user/package-camera',
                //     name: '/user/package-camera',
                //     component: () => import('./views/user-pages/package-camera/PackageCamera'),
                //     meta: {
                //         pageTitle: 'Bảng giá',
                //         rule: 'organization_user',
                //         parent: 'user-manage-camera'
                //     }
                // },
                // {
                //     path: '/user/stream-camera',
                //     name: '/user/stream-camera',
                //     component: () => import('./views/user-pages/stream/StreamCamera'),
                //     meta: {

                //         rule: 'organization_user',
                //     }
                // },
                // {
                //     path: '/user/play-back',
                //     name: '/user/play-back',
                //     component: () => import('./views/user-pages/playback/PlayBack'),
                //     meta: {
                //         pageTitle: '',
                //         rule: 'organization_user',
                //     }
                // },
                // {
                //     path: '/user/ai-restrictedarea',
                //     name: 'ai-restrictedarea',
                //     component: () => import('./views/user-pages/ai-restrictedarea/AIRestrictedarea'),
                //     meta: {
                //         pageTitle: 'Phát hiện xâm nhập',
                //         rule: 'organization_user',
                //     }
                // },
                // {
                //     path: '/user/ai-restrictedarea-history',
                //     name: 'ai-restrictedarea-history',
                //     component: () => import('./views/user-pages/ai-restrictedarea/AIRestrictedareaHistory'),
                //     meta: {
                //         pageTitle: 'Lịch sử xâm nhập',
                //         rule: 'organization_user',
                //     }
                // },
                // {
                //     path: '/user/face-recognition',
                //     name: 'face-recognition',
                //     component: () => import('./views/user-pages/face-recognition/FaceRecognition'),
                //     meta: {
                //         pageTitle: 'Nhận diện mặt',
                //         rule: 'organization_user',
                //     }
                // },
                // {
                //     path: '/user/add-face-recognition',
                //     name: '/user/add-face-recognition',
                //     component: () => import('./views/user-pages/face-recognition/FaceRecignitionInfomation'),
                //     meta: {
                //         pageTitle: 'Thêm sự kiện',
                //         rule: 'organization_user',
                //         parent: 'face-recognition'
                //     }
                // },
                // {
                //     path: '/user/edit-face-recognition',
                //     name: '/user/edit-face-recognition',
                //     component: () => import('./views/user-pages/face-recognition/FaceRecignitionInfomation'),
                //     meta: {
                //         rule: 'organization_user',
                //         parent: 'face-recognition',

                //     }
                // },
                // {
                //     path: '/user/face-recognition-register',
                //     name: 'face-recognition-register',
                //     component: () => import('./views/user-pages/face-recognition/FaceRecognitionRegister'),
                //     meta: {
                //         pageTitle: 'Danh sách đăng kí',
                //         rule: 'organization_user',
                //     }
                // },
                // {
                //     path: '/user/create-face-recognition-register',
                //     name: 'create-face-recognition-register',
                //     component: () => import('./views/user-pages/face-recognition/FaceRecognitionRegisterInformation'),
                //     meta: {
                //         pageTitle: 'Thêm mới đăng kí',
                //         rule: 'organization_user',
                //         parent: 'face-recognition-register'
                //     }
                // },
                // {
                //     path: '/user/update-face-recognition-register',
                //     name: 'update-face-recognition-register',
                //     component: () => import('./views/user-pages/face-recognition/FaceRecognitionRegisterInformation'),
                //     meta: {
                //         rule: 'organization_user',
                //         parent: 'face-recognition-register'
                //     }
                // },
                // {
                //     path: '/user/ai-restrictedarea-create',
                //     name: '/user/ai-restrictedarea-create',
                //     component: () => import('./views/user-pages/ai-restrictedarea/AIRestrictedareaInfomation'),
                //     meta: {
                //         pageTitle: 'Thêm sự kiện',
                //         rule: 'organization_user',
                //         parent: 'ai-restrictedarea'
                //     }
                // },
                // {
                //     path: '/user/ai-restrictedarea-update',
                //     name: '/user/ai-restrictedarea-update',
                //     component: () => import('./views/user-pages/ai-restrictedarea/AIRestrictedareaInfomation'),
                //     meta: {
                //         rule: 'organization_user',
                //         parent: 'ai-restrictedarea'
                //     }
                // },

                // External Device
                {
                    path: '/user/card-customer',
                    name: 'card-customer',
                    component: () => import('./views/user-pages/crm-module/card-customer/CustomerCardManager.vue'),
                    meta: {
                        pageTitle: 'navMenu.updateCamera',
                        rule: 'organization_user',
                        parent: 'card-customer'
                    }
                },
                {
                    path: '/user/card-customer-info',
                    name: 'card-customer-info',
                    component: () => import('./views/user-pages/crm-module/card-customer/CustomerCardInfomation.vue'),
                    meta: {
                        pageTitle: 'navMenu.updateCamera',
                        rule: 'organization_user',
                        parent: 'card-customer'
                    }
                },

                {
                    path: '/user/time-keeping',
                    name: 'time-keeping',
                    component: () => import('./views/user-pages/hrm-module/time-keeping/Employee'),
                    meta: {
                        pageTitle: 'Lịch sử chấm công',
                        rule: 'organization_user',
                        parent: 'time-keeping',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/history-file',
                    name: 'time-keeping-file',
                    component: () => import('./views/user-pages/hrm-module/history-file/ExportFileDetails'),
                    meta: {
                        pageTitle: 'Lịch sử xuất báo cáo',
                        rule: 'organization_user',
                        parent: 'time-keeping',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/time-keeping-detail',
                    name: 'time-keeping-detail',
                    component: () => import('./views/user-pages/hrm-module/time-keeping/TimeKeepingDetail'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'time-keeping',
                        space: 'hrm'
                    }
                },
                {
                    path: '/login',
                    name: 'login',
                    redirect: '/pages/login',
                },
                // Plate list
                {
                    path: '/user/place',
                    name: 'place',
                    component: () => import('./views/user-pages/hrm-module/daily-work/Place'),
                    meta: {
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },

                // Add place
                {
                    path: '/user/add-place',
                    name: 'add-place',
                    component: () => import('./views/user-pages/hrm-module/daily-work/PlaceInformation'),
                    meta: {
                        pageTitle: "Thêm địa điểm",
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                // Add place
                {
                    path: '/user/edit-place',
                    name: 'edit-place',
                    component: () => import('./views/user-pages/hrm-module/daily-work/PlaceInformation'),
                    meta: {
                        pageTitle: "Cập nhật địa điểm",
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                // Area
                {
                    path: '/user/area',
                    name: 'area',
                    component: () => import('./views/user-pages/hrm-module/daily-work/Area.vue'),
                    meta: {
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                // Add Area
                {
                    path: '/user/add-area',
                    name: 'add-area',
                    component: () => import('./views/user-pages/hrm-module/daily-work/AreaInformation.vue'),
                    meta: {
                        pageTitle: "Thêm Khu vực kiểm tra",
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                // edit Area
                {
                    path: '/user/edit-area',
                    name: 'edit-area',
                    component: () => import('./views/user-pages/hrm-module/daily-work/AreaInformation.vue'),
                    meta: {
                        pageTitle: "Cập nhật khu vực kiểm tra",
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                // Daily Work
                {
                    path: '/user/manage-branch-daily-work',
                    name: 'manage-branch-daily-work',
                    component: () => import('./views/user-pages/hrm-module/daily-work/OrganizationBranchDailyWork'),
                    meta: {
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                // Daily Work Detail
                {
                    path: '/user/daily-work-detail',
                    name: 'daily-work-detail',
                    component: () => import('./views/user-pages/hrm-module/daily-work/DailyWorkDetail'),
                    meta: {
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                // Daily Work Detail Information
                {
                    path: '/user/add-daily-work-detail',
                    name: 'add-daily-work-detail',
                    component: () => import('./views/user-pages/hrm-module/daily-work/DailyWorkDetailInformation'),
                    meta: {
                        pageTitle: "Thêm hạng mục kiểm tra",
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                // Daily Work Detail Information
                {
                    path: '/user/edit-daily-work-detail',
                    name: 'edit-daily-work-detail',
                    component: () => import('./views/user-pages/hrm-module/daily-work/DailyWorkDetailInformation'),
                    meta: {
                        pageTitle: 'Cập nhật hạng mục',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/add-daily-work',
                    name: 'user-add-daily-work',
                    component: () => import('./views/user-pages/hrm-module/dailywork-result/DailyWorkInformation'),
                    meta: {
                        pageTitle: 'Thêm công việc hàng ngày',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/edit-daily-work',
                    name: 'user-edit-daily-work',
                    component: () => import('./views/user-pages/hrm-module/dailywork-result/DailyWorkInformation'),
                    meta: {
                        pageTitle: 'Cập nhật công việc hàng ngày',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/manage-daily-work-by-day',
                    name: 'manage-daily-work-shift-by-day',
                    component: () => import('./views/user-pages/hrm-module/workshiftbyday/Employee'),
                    meta: {
                        pageTitle: 'Nhân sự làm việc theo ngày',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/daily-work-result',
                    name: 'daily-work-result',
                    component: () => import('./views/user-pages/hrm-module/dailywork-result/Employee'),
                    meta: {
                        pageTitle: 'Giao việc thủ công',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/add-daily-work',
                    name: 'add-daily-work',
                    component: () => import('./views/user-pages/hrm-module/dailywork-result/DailyWorkInformation'),
                    meta: {
                        pageTitle: 'Thêm công việc mới',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/edit-daily-work',
                    name: 'edit-daily-work',
                    component: () => import('./views/user-pages/hrm-module/dailywork-result/DailyWorkInformation'),
                    meta: {
                        pageTitle: 'Cập nhật công việc',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/register-daily-work',
                    name: 'manage-employee-daily-work',
                    component: () => import('./views/user-pages/hrm-module/daily-work/Employee'),
                    meta: {
                        pageTitle: 'Đăng ký công việc hàng ngày',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/register-employee-daily-work',
                    name: 'register-employee-daily-work',
                    component: () => import('./views/user-pages/hrm-module/daily-work/EmployeeInformation'),
                    meta: {
                        pageTitle: 'Đăng ký công việc hàng ngày',
                        rule: 'organization_user',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/manage-daily-work-branch',
                    name: 'manage-daily-work-branch',
                    component: () => import('./views/user-pages/hrm-module/daily-work/DailyWork'),
                    meta: {
                        pageTitle: 'Ca làm việc theo ngày',
                        rule: 'organization_user',
                        parent: 'manage-work-shift-by-day',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/over-time-manager',
                    name: 'user-over-time-manager',
                    component: () => import('./views/user-pages/hrm-module/over-time/Overtime.vue'),
                    meta: {
                        pageTitle: 'Ca làm thêm',
                        rule: 'organization_user',
                        parent: 'user-over-time-manager',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/over-time',
                    name: 'user-over-time',
                    component: () => import('./views/user-pages/hrm-module/over-time/OvertimeInfomation.vue'),
                    meta: {
                        pageTitle: 'Ca làm thêm',
                        rule: 'organization_user',
                        parent: 'user-over-time-manager',
                        space: 'hrm'
                    }
                },

                // Policy
                {
                    path: '/user/manage-policy',
                    name: 'user-manage-policy',
                    component: () => import('./views/user-pages/hrm-module/policy/PolicyManage.vue'),
                    meta: {
                        pageTitle: 'navMenu.policy',
                        rule: 'organization_user',
                        parent: 'user-manage-policy',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/manage-policy-info',
                    name: 'user-manage-policy-info',
                    component: () =>
                        import('./views/user-pages/hrm-module/policy/PolicyInfo.vue'),
                    meta: {
                        pageTitle: 'policy.info',
                        rule: 'organization_user',
                        parent: 'user-manage-policy',
                        space: 'hrm'
                    }
                },

                // Holiday
                {
                    path: '/user/manage-holiday',
                    name: 'user-manage-holiday',
                    component: () => import('./views/user-pages/hrm-module/holiday/HolidayManage.vue'),
                    meta: {
                        pageTitle: 'navMenu.holiday',
                        rule: 'organization_user',
                        parent: 'user-manage-holiday',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/manage-holiday-info',
                    name: 'user-manage-holiday-info',
                    component: () =>
                        import('./views/user-pages/hrm-module/holiday/HolidayInfo.vue'),
                    meta: {
                        pageTitle: 'holiday.info',
                        rule: 'organization_user',
                        parent: 'user-manage-holiday',
                        space: 'hrm'
                    }
                },

                // Detail On Leave
                {
                    path: '/user/detail-on-leave',
                    name: 'user-detail-on-leave',
                    component: () =>
                        import('./views/user-pages/hrm-module/leave/DetailOnLeave'),
                    meta: {
                        pageTitle: 'Chi tiết thông tin nghỉ phép nhân viên',
                        rule: 'organization_user',
                        parent: 'user-manage-policy',
                        space: 'hrm'
                    }
                },

                //Department
                {
                    path: '/user/manage-department',
                    name: 'user-manage-department',
                    component: () => import('./views/user-pages/hrm-module/department/Department'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-manage-department',
                        space: 'hrm'
                    }
                },
                {
                    path: '/user/department-info',
                    name: 'user-department-info',
                    component: () => import('./views/user-pages/hrm-module/department/DepartmentInfo'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-manage-department',
                        space: 'hrm'
                    }
                },

                //Service Packs
                {
                    path: '/user/manage-service-packs',
                    name: 'user-manage-service-packs',
                    component: () => import('./views/user-pages/crm-module/service-packs/ManageServicePacks'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-manage-service-packs',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/info-service-packs',
                    name: 'user-info-service-packs',
                    component: () => import('./views/user-pages/crm-module/service-packs/InfoServicePacks'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-manage-service-packs',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/manage-service-type',
                    name: 'user-manage-service-type',
                    component: () => import('./views/user-pages/crm-module/service-type/ManageServiceType'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-manage-service-type',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/info-service-type',
                    name: 'user-info-service-type',
                    component: () => import('./views/user-pages/crm-module/service-type/InfoServiceType'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-manage-service-type',
                        space: 'crm'
                    }
                },

                // Incentives
                // {
                //     path: '/user/manage-incentives',
                //     name: 'user-manage-incentives',
                //     component: () => import('./views/user-pages/incentives/ManageIncentives'),
                //     meta: {
                //         rule: 'organization_user',
                //         parent: 'user-manage-incentives',
                //         space: 'crm'
                //     }
                // },
                //
                // {
                //     path: '/user/info-incentives',
                //     name: 'user-info-incentives',
                //     component: () => import('./views/user-pages/incentives/InfoIncentives'),
                //     meta: {
                //         rule: 'organization_user',
                //         parent: 'user-manage-incentives',
                //         space: 'crm'
                //     }
                // },
                // {
                //     path: '/user/redemption',
                //     name: 'user-redemption',
                //     component: () => import('./views/user-pages/redemption/ManageRedemption'),
                //     meta: {
                //         rule: 'organization_user',
                //         parent: 'user-redemption',
                //         space: 'crm'
                //     }
                // },

                //Feedback
                {
                    path: '/user/feedback',
                    name: 'user-feedback',
                    component: () => import('./views/user-pages/crm-module/feedback/Feedback'),
                    meta: {
                        rule: 'organization_user',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/feedback-info',
                    name: 'user-feedback-info',
                    component: () => import('./views/user-pages/crm-module/feedback/FeedbackInfo'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-feedback',
                        space: 'crm'
                    }
                },

                //Booking
                {
                    path: '/user/booking-schedule',
                    name: 'user-booking-schedule',
                    component: () => import('./views/user-pages/crm-module/booking/Booking'),
                    meta: {
                        rule: 'organization_user',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/booking-schedule-history',
                    name: 'user-book-schedule-history',
                    component: () => import('./views/user-pages/crm-module/booking/BookingHistory'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-book-schedule-history',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/booking-schedule-info',
                    name: 'user-booking-schedule-info',
                    component: () => import('./views/user-pages/crm-module/booking/BookingInfo'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-book-schedule-history',
                        space: 'crm'
                    }
                },

                // Service package of Branch
                {
                    path: '/user/assign-services-branch',
                    name: 'user-assign-services-branch',
                    component: () => import('./views/user-pages/hrm-module/branch/ServicePackageOfBranch'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-manage-department',
                        space: 'hrm'
                    }
                },

                // Combo Package Service
                {
                    path: '/user/manage-service-combo',
                    name: 'user-service-combo',
                    component: () => import('./views/user-pages/crm-module/service-combo/ComboService'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-service-combo',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/info-service-combo',
                    name: 'user-info-service',
                    component: () => import('./views/user-pages/crm-module/service-combo/ComboServiceInfo'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-service-combo',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/newfeed',
                    name: 'user-newfeed',
                    component: () => import('./views/user-pages/crm-module/newfeed/NewFeed'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-newfeed',
                        space: 'crm'
                    }
                },
                // {
                //     path: '/user/posts-details',
                //     name: 'user-posts-details',
                //     component: () => import('./views/user-pages/newfeed/PostsInfo'),
                //     meta: {
                //         rule: 'organization_user',
                //         parent: 'user-newfeed',
                //         space: 'crm'
                //     }
                // },
                {
                    path: '/user/posts-waiting-for-approval',
                    name: 'user-posts-waiting-for-approval',
                    component: () => import('./views/user-pages/crm-module/newfeed/PostsWaitingForApproval'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-posts-waiting-for-approval',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/posts-info',
                    name: '/user/posts-info',
                    component: () => import('./views/user-pages/crm-module/newfeed/PostsInfo'),
                    meta: {
                        rule: "organization_user",
                        parent: 'user-newfeed',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/posts-approved',
                    name: 'user-posts-approved',
                    component: () => import('./views/user-pages/crm-module/newfeed/PostsApproved'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-posts-approved',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/posts-rejected',
                    name: 'user-posts-rejected',
                    component: () => import('./views/user-pages/crm-module/newfeed/PostsRejected'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-posts-rejected',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/restricted-keywords',
                    name: 'user-restricted-keywords',
                    component: () => import('./views/user-pages/crm-module/newfeed/RestrictedKeywords'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-restricted-keywords',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/restricted-keywords-info',
                    name: 'user-restricted-keywords-info',
                    component: () => import('./views/user-pages/crm-module/newfeed/RestrictedKeywordsInfo'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-restricted-keywords',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/overview-call-center',
                    name: 'user-overview-call-center',
                    component: () => import('./views/user-pages/crm-module/call-center/Overview'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-overview-call-center',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/management-configuration',
                    name: 'user-management-configuration',
                    component: () => import('./views/user-pages/crm-module/call-center/ManagementConfiguration.vue'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'management-configuration',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/call-history',
                    name: 'user-call-history',
                    component: () => import('./views/user-pages/crm-module/call-center/CallHistory'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-call-history',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/call-monitoring',
                    name: 'user-call-monitoring',
                    component: () => import('./views/user-pages/crm-module/call-center/CallMonitoring'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-call-monitoring',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/active-call',
                    name: 'user-active-call',
                    component: () => import('./views/user-pages/crm-module/call-center/ActiveCall'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-active-call',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/login-session',
                    name: 'user-login-session',
                    component: () => import('./views/user-pages/crm-module/call-center/ LoginSession.vue'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-login-session',
                        space: 'crm'
                    }
                },

                // Settings
                {
                    path: '/user/workspace-setting',
                    name: 'user-workspace-setting',
                    component: () => import('./views/admin-pages/workspace-setting/WorkspaceSetting'),
                    meta: {
                        rule: 'admin',
                        parent: 'user-workspace-setting',
                    }
                },

                {
                    path: '/user/workspace-setting-info',
                    name: 'user-workspace-setting-info',
                    component: () => import('./views/admin-pages/workspace-setting/WorkspaceSettingInfo'),
                    meta: {
                        rule: 'admin',
                        parent: 'user-workspace-setting',
                    }
                },

                // Medical examination process
                {
                    path: '/user/waiting-for-reception',
                    name: 'waiting-for-reception',
                    component: () => import('./views/user-pages/crm-module/medical-examination-process/WaitingForReception'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'waiting-for-reception',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/reception-step',
                    name: 'reception-step',
                    component: () => import('./views/user-pages/crm-module/medical-examination-process/ReceptionStep'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'reception-step',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/consulting-step',
                    name: 'consulting-step',
                    component: () => import('./views/user-pages/crm-module/medical-examination-process/ConsultingStep'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'consulting-step',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/fee-collection-step',
                    name: 'fee-collection-step',
                    component: () => import('./views/user-pages/crm-module/medical-examination-process/FeeCollectionStep'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'fee-collection-step',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/paraclinical-examination-step',
                    name: 'paraclinical-examination-step',
                    component: () => import('./views/user-pages/crm-module/medical-examination-process/ParaclinicalExaminationStep'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'paraclinical-examination-step',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/completed-step',
                    name: 'completed-step',
                    component: () => import('./views/user-pages/crm-module/medical-examination-process/CompletedStep'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'completed-step',
                        space: 'crm'
                    }
                },

                //Care
                {
                    path: '/user/manage-care-dashboad',
                    name: 'user-manage-care-dashboad',
                    component: () => import('./views/user-pages/crm-module/care/CareSms'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-manage-care-dashboad',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/manage-care-sms',
                    name: 'user-manage-care-sms',
                    component: () => import('./views/user-pages/crm-module/care/CareSms'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-manage-care-sms',
                        space: 'crm'
                    }
                },
                {
                    path: '/user/info-news-sms',
                    name: 'user-info-news-sms',
                    component: () => import('./views/user-pages/crm-module/care/InfoNewsSms'),
                    meta: {
                        pageTitle: 'Thêm sự kiện SMS',
                        rule: "organization_user",
                        parent: 'user-manage-care-sms',
                        space: 'crm'
                    }
                },

                /*{
                    path: '/user/manage-care-email',
                    name: 'user-manage-care-email',
                    component: () => import('./views/user-pages/crm-module/care/CareSms'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-manage-care-sms',
                        space: 'crm'
                    }
                },*/

                // {
                //     path: '/user/details-file-in-consulting',
                //     name: 'details-file-in-consulting',
                //     component: () => import('./views/user-pages/medical-examination-process/details-file/DetailsFileInConsulting'),
                //     meta: {
                //         rule: 'organization_user',
                //         parent: 'consulting-step',
                //         space: 'crm',
                //     }
                // },
                // {
                //     path: '/user/details-file-in-fee',
                //     name: 'details-file-in-fee',
                //     component: () => import('./views/user-pages/medical-examination-process/details-file/DetailsFileInFee'),
                //     meta: {
                //         rule: 'organization_user',
                //         parent: 'fee-collection-step',
                //         space: 'crm',
                //     }
                // },
                // {
                //     path: '/user/details-file-in-examination',
                //     name: 'details-file-in-examination',
                //     component: () => import('./views/user-pages/medical-examination-process/details-file/DetailsFileInExamination'),
                //     meta: {
                //         rule: 'organization_user',
                //         parent: 'paraclinical-examination-step',
                //         space: 'crm',
                //     }
                // },

                //Setting CRM
                {
                    path: '/user/setting-crm',
                    name: 'user-setting-crm',
                    component: () => import('./views/user-pages/crm-module/setting-crm/SettingCRM'),
                    meta: {
                        rule: 'organization_user',
                        space: 'crm'
                    }
                },

                //Setting HRM
                // {
                //     path: '/user/setting-pancake-token',
                //     name: 'user-setting-pancake-token',
                //     component: () => import('./views/user-pages/hrm-module/setting-hrm/PancakeToken'),
                //     meta: {
                //         rule: 'organization_user',
                //         parent: 'user-setting-pancake-token',
                //         space: 'hrm'
                //     }
                // }
            ],
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('../src/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/pages/login',
                    name: 'page-login',
                    component: () => import('../src/views/pages/Login.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/pages/register',
                    name: 'page-register',
                    component: () => import('../src/views/pages/register/Register.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/pages/active',
                    name: 'page-active',
                    component: () => import('../src/views/pages/register/Active.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/pages/active-email',
                    name: 'page-active-email',
                    component: () => import('../src/views/pages/register/ActiveEmail.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('../src/views/pages/Error404.vue'),
                },

                //============Common page========
                {
                    path: '/pages/not-authorized',
                    name: 'page-not-authorized',
                    component: () => import('../src/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
                // Guide
                {
                    path: '/pages/guide',
                    name: 'page-guide',
                    component: () => import('../src/views/pages/Guide.vue'),
                    meta: {
                        rule: 'public'
                    }
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        },

        // =============================================================================
        // WORK SPACE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('../src/layouts/full-page/WorkSpace.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/pages/select-work-space',
                    name: 'work-space',
                    component: () => import('../src/views/pages/WorkSpace.vue'),
                    meta: {
                        rule: 'public',
                    }
                },

                {
                    path: '/user/settings',
                    name: 'user-settings',
                    component: () => import('./views/user-pages/setting/SettingWorkspace'),
                    meta: {
                        rule: 'organization',
                        parent: 'user-settings',
                    }
                },

                // Message
                {
                    path: '/user/message',
                    name: 'user-message',
                    component: () => import('./views/user-pages/chat/Chat'),
                    meta: {
                        rule: 'organization_user',
                        parent: 'user-message',
                    }
                },


            ]
        }
    ],
});
router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg');
    if (appLoading) {
        appLoading.style.display = "none";
    }

    // Destroy vs-popup when change component
    document.querySelectorAll('body > div.vs-component').forEach(el => {
        el.remove()
    })
    document.querySelectorAll('body > div.vs-content-sidebar').forEach(el => {
        el.remove()
    })
});

export default router
